import { Profile } from "../../../hooks/use-get-profile";
import { isRnRUser } from "../../../shared/utils/helpers";
import { EXPERIENCE_STEP_TWO_INITIAL_VALUES } from "../constants/step-two-constants";
import {
    ExperienceStepOneInitialValues,
    ExperienceStepTwoInitialValues,
} from "../types/experience.types";
import { KEY_IS_EXPERIENCED } from "../../../shared/constants";

export const transformBodyToExperienceForm = (profileData: Profile) => {
    let experienceDataStepOne = {
        hasWorkExperience: null as unknown as boolean,
        yearsOfExperience: null as unknown as number,
        monthsOfExperience: null as unknown as number,
    } as ExperienceStepOneInitialValues;

    let experienceId = null;

    /**
     * Profile level data
     */
    if (profileData.is_experienced) {
        sessionStorage.setItem(KEY_IS_EXPERIENCED, "true")

        experienceDataStepOne.hasWorkExperience = true;
        if (
            typeof profileData.months_of_experience === "number" &&
            profileData.months_of_experience > 0
        ) {
            experienceDataStepOne.yearsOfExperience = Math.floor(
                (profileData.months_of_experience || 0) / 12
            );
            experienceDataStepOne.monthsOfExperience = Math.floor(
                (profileData.months_of_experience || 0) % 12
            );
        }
    } else {
        sessionStorage.setItem(KEY_IS_EXPERIENCED, "false")
        experienceDataStepOne.hasWorkExperience = null;
    }

    /**
     * Experience data
     */

    const experience = Array.isArray(profileData.experiences)
        ? profileData.experiences[0]
        : null;

    if (experience) {
        if (experience.id) {
            experienceId = experience.id;
        }

        let experienceDataStepTwo: ExperienceStepTwoInitialValues = {
            ...EXPERIENCE_STEP_TWO_INITIAL_VALUES,
        };

        if (experience.job_title) {
            experienceDataStepTwo.jobTitle = {
                id: experience.job_title.id,
                display_name: experience.job_title.title,
                classification: experience?.job_title?.classification || "",
            };
        }

        if (experience.organization) {
            experienceDataStepTwo.company = {
                id: experience.organization.id,
                name: experience.organization.title,
                gumlet_url: experience.organization.gumlet_url,
            };
        }

        if (experience.industry) {
            experienceDataStepTwo.industry = {
                id: experience.industry.id,
                title: experience.industry.title,
            };
        }

        if(experience.skills){
            experienceDataStepTwo.skills = experience.skills;
        }

        if (experience.department) {
            experienceDataStepTwo.department = {
                id: experience.department.id,
                title: experience.department.title,
            };
        }

        if (experience.sub_department) {
            experienceDataStepTwo.subDepartment = {
                id: experience.sub_department.id,
                title: experience.sub_department.title,
            };
        }

        if (experience.start) {
            experienceDataStepTwo.startDate = experience.start;
            const date = new Date(experience.start);
            experienceDataStepTwo.start = {
                year: date.getFullYear(),
                month: date.getMonth(),
            };
        }

        if (experience.end) {
            experienceDataStepTwo.endDate = experience.end;
            const date = new Date(experience.end);
            experienceDataStepTwo.end = {
                year: date.getFullYear(),
                month: date.getMonth(),
            };
        }

        // if (experience.ongoing) {
        experienceDataStepTwo.currentlyWorkingHere = !!experience.ongoing;
        // }

        if (profileData?.current_salary_v2) {
            experienceDataStepTwo.currentMonthlySalary = String(
                profileData?.current_salary_v2
            );
        }

        if (experience.employment_type) {
            experienceDataStepTwo.employmentType = experience.employment_type;
        }

        if (typeof profileData.notice_period === "number") {
            experienceDataStepTwo.noticePeriod = profileData.notice_period;
        }

        return {
            stepOne: experienceDataStepOne,
            stepTwo: isRnRUser()
                ? EXPERIENCE_STEP_TWO_INITIAL_VALUES
                : experienceDataStepTwo,
            latestExpereince: { ...experienceDataStepTwo, id: experienceId as string },
            id: experienceId,
            allExperiences: profileData.experiences,
        };
    }

    return {
        id: experienceId,
        stepOne: experienceDataStepOne,
        stepTwo: EXPERIENCE_STEP_TWO_INITIAL_VALUES,
        latestExpereince: {} as ExperienceStepTwoInitialValues & { id: string },
        allExperiences: profileData.experiences,
    };
};
